export default "__VITE_ASSET__Bw4$saBS__"